import {
  remoteResourceInitialState,
  remoteResourceLoadFailure,
  remoteResourceLoading,
  remoteResourceLoadSuccess,
} from '../../helpers';
import { AnalyticsSummary } from '../../services/AnalyticsApi';
import { Actions, ActionType, State } from './types';

const analyticsSummaryInitialState: AnalyticsSummary = {
  executions: 0,
  exports: 0,
  errors: 0,
  users: 0,
  countries: 0,
  roles: 0,
};

const initialState: State = {
  period: 'daily',
  summary: remoteResourceInitialState(analyticsSummaryInitialState),
  reportsUsage: remoteResourceInitialState([]),
  reportsTop: remoteResourceInitialState([]),
  usersActivity: remoteResourceInitialState([]),
  countriesActivity: remoteResourceInitialState([]),
  rolesActivity: remoteResourceInitialState([]),
  countriesUsers: remoteResourceInitialState([]),
  countryReportsActivity: remoteResourceInitialState([]),
  roleReportsActivity: remoteResourceInitialState([]),
  countryRolesActivity: remoteResourceInitialState([]),
};

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionType.findAnalyticsRequested:
      return {
        period: action.period || state.period,
        summary: remoteResourceLoading(analyticsSummaryInitialState),
        reportsUsage: remoteResourceLoading([]),
        reportsTop: remoteResourceLoading([]),
        usersActivity: remoteResourceLoading([]),
        countriesActivity: remoteResourceLoading([]),
        rolesActivity: remoteResourceLoading([]),
        countriesUsers: remoteResourceLoading([]),
        countryReportsActivity: remoteResourceLoading([]),
        roleReportsActivity: remoteResourceLoading([]),
        countryRolesActivity: remoteResourceLoading([]),
      };
    case ActionType.findAnalyticsSummarySuccess:
      return {
        ...state,
        summary: remoteResourceLoadSuccess(action.summary),
      };
    case ActionType.findAnalyticsUsageSuccess:
      return {
        ...state,
        reportsUsage: remoteResourceLoadSuccess(action.reportsUsage),
      };
    case ActionType.findAnalyticsTopSuccess:
      return {
        ...state,
        reportsTop: remoteResourceLoadSuccess(action.reportsTop),
      };
    case ActionType.findAnalyticsUsersSuccess:
      return {
        ...state,
        usersActivity: remoteResourceLoadSuccess(action.usersActivity),
      };
    case ActionType.findAnalyticsCountriesSuccess:
      return {
        ...state,
        countriesActivity: remoteResourceLoadSuccess(action.countriesActivity),
      };
    case ActionType.findAnalyticsRolesSuccess:
      return {
        ...state,
        rolesActivity: remoteResourceLoadSuccess(action.rolesActivity),
      };
    case ActionType.findAnalyticsCountriesUsersSuccess:
      return {
        ...state,
        countriesUsers: remoteResourceLoadSuccess(action.countriesUsers),
      };
    case ActionType.findAnalyticsCountryReportsSuccess:
      return {
        ...state,
        countryReportsActivity: remoteResourceLoadSuccess(action.countryReportsActivity),
      };
    case ActionType.findAnalyticsRoleReportsSuccess:
      return {
        ...state,
        roleReportsActivity: remoteResourceLoadSuccess(action.roleReportsActivity),
      };
    case ActionType.findAnalyticsCountryRolesSuccess:
      return {
        ...state,
        countryRolesActivity: remoteResourceLoadSuccess(action.countryRolesActivity),
      };
    case ActionType.findAnalyticsFailure:
      return {
        period: state.period,
        summary: remoteResourceLoadFailure(analyticsSummaryInitialState, action.error),
        reportsUsage: remoteResourceLoadFailure([], action.error),
        reportsTop: remoteResourceLoadFailure([], action.error),
        usersActivity: remoteResourceLoadFailure([], action.error),
        countriesActivity: remoteResourceLoadFailure([], action.error),
        rolesActivity: remoteResourceLoadFailure([], action.error),
        countriesUsers: remoteResourceLoadFailure([], action.error),
        countryReportsActivity: remoteResourceLoadFailure([], action.error),
        roleReportsActivity: remoteResourceLoadFailure([], action.error),
        countryRolesActivity: remoteResourceLoadFailure([], action.error),
      };
    default:
      return state;
  }
};

export default reducer;
